import { createContext } from 'react'

import { ToastMessage } from 'primereact/toast'

export type ToastContextType = {
  showToast: (message: ToastMessage) => void
  replaceToast: (message: ToastMessage) => void
  removeToast: (message: ToastMessage) => void
  clearAllToasts: () => void
}

const stub = (): never => {
  throw new Error('You forgot to wrap your component in <ToastContextProvider>')
}

const initialValue: ToastContextType = {
  clearAllToasts: stub,
  removeToast: stub,
  replaceToast: stub,
  showToast: stub,
}

export const ToastContext = createContext<ToastContextType>(initialValue)
